import _ from 'underscore';

import { getBidFields } from './bid-fields';
import { EntityFields } from './entity-fields';
import { OtherFields } from './other-fields';

function removeFromBlacklist(fields, subFieldsBlacklist) {
  const prunedFields = fields;

  _.each(prunedFields, (field) => {
    field.fields = _.reject(field.fields, (subField) => { //eslint-disable-line
      return _.contains(subFieldsBlacklist, subField.property);
    });
  });

  return prunedFields;
}

export function getImportOptionFields({
  i18n,
  logTrace,
  model,
  subFieldsBlacklist,
  flattenedSchemaGenerator,
  config,
  UetTagSelectorView,
  minAdjust,
  maxAdjust,
  isMultiAccountImport,
  isForVNext,
  hideEntityAdvancedOptions,
  otherFieldsExpanded = false,
  helpIds,
  isPauseAdGroupIfNoLocationSupportedEnabled,
  isAudienceTargetForFBImportOptionEnabled,
  shouldEnableBSCSmartImport = false,
  shouldShowCurrencyConvertor = false,
  importAccountCurrencyTitle,
  isGoogleLogoExtensionImportOptionEnabled = false,
  isGoogleUpdateAdUrlsImportOptionEnabled = false,
  isGoogleUpdateSitelinkUrlsImportOptionEnabled = false,
  isGoogleAccountNegativeKeywordsImportOptionEnabled = false,
  isGoogleAdCustomizerAttributesImportOptionEnabled = false,
  isGoogleConversionGoalsImportOptionEnabled = false,
  isBrandSuitabilityImportOptionEnabled = false,
}) {
  const market = config.get('CurrentUser').Market;
  const permissions = config.get('Permissions') || {};
  const isPageFeedEnabled = permissions.IsPageFeedImportOptionEnabled;
  const isDSAMixedModeCampaignEnabled = permissions.IsDSAMixedModeCampaignEnabled;
  // eslint-disable-next-line max-len
  const isGoogleImageExtensionImportOptionEnabled = permissions.IsGoogleImageExtensionImportOptionEnabled;

  const entityFieldsGenerator = new EntityFields({
    i18n,
    model,
    flattenedSchemaGenerator,
    subFieldsBlacklist,
    isPageFeedEnabled,
    isMultiAccountImport,
    UetTagSelectorView,
    hideAdvancedOptions: hideEntityAdvancedOptions,
    isGoogleImageExtensionImportOptionEnabled,
    isGoogleLogoExtensionImportOptionEnabled,
    isGoogleUpdateAdUrlsImportOptionEnabled,
    isGoogleUpdateSitelinkUrlsImportOptionEnabled,
    isGoogleAccountNegativeKeywordsImportOptionEnabled,
    isGoogleAdCustomizerAttributesImportOptionEnabled,
    isGoogleConversionGoalsImportOptionEnabled,
    isBrandSuitabilityImportOptionEnabled,
  });
  const otherFieldsGenerator = new OtherFields({
    i18n,
    model,
    flattenedSchemaGenerator,
    isDSAMixedModeCampaignEnabled,
    isForVNext,
    isExpanded: otherFieldsExpanded,
    isPauseAdGroupIfNoLocationSupportedEnabled,
    isAudienceTargetForFBImportOptionEnabled,
    shouldEnableBSCSmartImport,
    permissions,
  });

  const bidFields = removeFromBlacklist(
    getBidFields({
      i18n,
      logTrace,
      model,
      permissions,
      market,
      minAdjust,
      maxAdjust,
      shouldShowCurrencyConvertor,
      importAccountCurrencyTitle,
    }),
    subFieldsBlacklist
  );
  const entityFields =
    removeFromBlacklist(entityFieldsGenerator.getEntityFields(helpIds), subFieldsBlacklist);
  const otherFields =
    removeFromBlacklist(otherFieldsGenerator.getOtherFields(), subFieldsBlacklist);

  return [].concat(entityFields, bidFields, otherFields);
}
